import { render, staticRenderFns } from "./place-info.vue?vue&type=template&id=5cc2085e&scoped=true&"
import script from "./place-info.vue?vue&type=script&lang=js&"
export * from "./place-info.vue?vue&type=script&lang=js&"
import style0 from "./place-info.vue?vue&type=style&index=0&id=5cc2085e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc2085e",
  null
  
)

export default component.exports